import { render, staticRenderFns } from "./BaseFileInput.vue?vue&type=template&id=231b6604"
import script from "./BaseFileInput.vue?vue&type=script&lang=js"
export * from "./BaseFileInput.vue?vue&type=script&lang=js"
import style0 from "./BaseFileInput.vue?vue&type=style&index=0&id=231b6604&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports